<template>
    <FormGroup :label="translate('labels.name')">
        <Input v-model="category.name" type="text" />
    </FormGroup>
    <FormGroup :label="translate('labels.markup')">
        <Input v-model="category.markup" type="number" />
    </FormGroup>
</template>
<script>
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';

export default {
    name: 'CategoryFieldsetGroup',
    components: {
        FormGroup, Input
    },
    emits: [],
    props: {
        category: {
            type: Object,
            required: true
        }
    }
}
</script>
